import {ServiceQuery} from "../queries/ServiceQuery";
import {AdviceQuery} from "../../advice/queries/AdviceQuery";


const useServiceByCommunity = () => {

    const findByCommunity = async (communityId) => {
        return await Promise.all([ServiceQuery.getServiceByCommunity(communityId), ServiceQuery.getAdviceByCommunity(communityId)]).then( services => {
            return services.flat(Infinity);
        } )
    }



    return {findByCommunity}
}

export {useServiceByCommunity}
